import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { WritableAgentType } from 'constants/assist/agentType';
import { CentsAssistInfo, WelcomeMessages, EscalationPhoneNumbers } from './getCentsAssistInfo';

export interface EditCentsAssistInfoPayload {
  businessId: number;
  welcomeMessages?: WelcomeMessages;
  hoursLocationMessage?: string;
  servicesPricingMessage?: string;
  escalationProtocol?: string;
  upsellProtocol?: string;
  faqs?: string;
  escalationPhoneNumbers?: EscalationPhoneNumbers;
  transactionalPhoneNumber?: string;
  businessPhoneNumber?: string;
  offersPud?: boolean;
  sendOrderLinkViaSms?: boolean;
  bypassCallTransferWithEscalation?: boolean;
  enableCentsSupport?: boolean;
  isLocked?: boolean;
  agentId?: string;
  /** Only CUSTOM, or null to hand control back to auto-derivation; anything else 422s. */
  agentType?: WritableAgentType;
  supportsCardBalance?: boolean;
}

export const editCentsAssistInfo = (
  data: EditCentsAssistInfoPayload,
): AxiosPromise<CentsAssistInfo> => {
  return httpClient({
    method: 'PATCH',
    url: '/assist/info',
    data,
  });
};
